// extracted by mini-css-extract-plugin
export var numpadContainer = "_js-1";
export var phoneButton = "_js-0";